import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { X } from "lucide-react";

export default function EulaModal({ open, onClose }) {
    const [text, setText] = useState("");
    const [err, setErr] = useState(null);

    useEffect(() => {
        if (!open || text) return;
        const url = `${process.env.PUBLIC_URL || ""}/eula.md`;
        fetch(url)
            .then((r) => {
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                return r.text();
            })
            .then(setText)
            .catch((e) => setErr(e.message));
    }, [open, text]);

    useEffect(() => {
        if (!open) return;
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            data-testid="eula-modal"
            className="fixed inset-0 z-50 flex items-center justify-center px-4 py-8"
            onClick={onClose}
        >
            <div className="absolute inset-0 bg-[#050B14]/85 backdrop-blur-md" />
            <div
                className="relative codex-card w-full max-w-3xl max-h-[85vh] flex flex-col overflow-hidden"
                onClick={(e) => e.stopPropagation()}
            >
                <header className="flex items-center justify-between gap-3 px-5 py-3 border-b border-[#D4AF37]/30 bg-[#050B14]/40">
                    <div>
                        <div className="font-mono-os text-[10px] tracking-[0.32em] uppercase text-[#D4AF37]/80">
                            License & Terms
                        </div>
                        <h2 className="font-serif-display text-lg sm:text-xl text-[#F9E596] leading-tight">
                            End-User License Agreement
                        </h2>
                    </div>
                    <button
                        data-testid="eula-modal-close"
                        onClick={onClose}
                        className="codex-icon-button"
                        aria-label="Close"
                    >
                        <X size={16} strokeWidth={1.8} />
                    </button>
                </header>
                <div className="flex-1 overflow-y-auto scroll-thin px-5 sm:px-8 py-6">
                    {err && (
                        <p className="text-[#F87171] text-sm">
                            Could not load the EULA: {err}
                        </p>
                    )}
                    {!err && !text && (
                        <p className="text-[#94A3B8] text-sm font-mono-os tracking-[0.18em] uppercase">
                            Loading…
                        </p>
                    )}
                    {text && (
                        <article className="eula-prose">
                            <ReactMarkdown>{text}</ReactMarkdown>
                        </article>
                    )}
                </div>
                <footer className="px-5 py-3 border-t border-[#D4AF37]/25 bg-[#050B14]/40 text-center">
                    <button
                        data-testid="eula-modal-close-bottom"
                        onClick={onClose}
                        className="codex-button text-[10px]"
                    >
                        Close
                    </button>
                </footer>
            </div>
        </div>
    );
}
